import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextWithIconComponent } from '../../../../shared/components/text-with-icon/text-with-icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-device-action-trigger',
  imports: [TextWithIconComponent, TranslatePipe, MatTooltip],
  templateUrl: './device-action-trigger.component.html',
  styleUrl: './device-action-trigger.component.scss',
})
export class DeviceActionTriggerComponent {
  @Input() disabled: boolean = false;
  @Input() isActive: boolean = false;
  @Input() isPending: boolean = false;
  @Input() vertical: boolean = false;
  @Input() transparent: boolean = false;
  @Input() size: 'md' | 'lg' = 'md';
  @Output() triggerDeviceAction = new EventEmitter<{ value: boolean }>();

  onTriggerDeviceAction(value: boolean, event: MouseEvent) {
    event.stopPropagation();
    if (this.disabled) return;
    this.triggerDeviceAction.emit({ value });
  }
}
